import React from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DnsIcon from '@mui/icons-material/Dns'
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf'
import HomeIcon from '@mui/icons-material/Home'
import SpeedIcon from '@mui/icons-material/Speed'
import { NavLink } from 'react-router'
import cnergiLogo from '../resources/CNERGI_PNG@4x.png'
import './MainDashboardSidebar.css'

function getNavButtonClass(isActive = false) {
  return `dashboard-sidebar__button ${isActive ? 'dashboard-sidebar__button--active' : ''}`
}

function MainDashboardSidebar() {
  const navItems = [
    { label: 'Home', icon: HomeIcon, to: '/maindash', end: true },
    { label: 'Device List', icon: DnsIcon, to: '/maindash/devices' },
    { label: 'GreenScore Scoreboard', icon: EnergySavingsLeafIcon, to: '/maindash/greenscore' },
    { label: 'Performance', icon: SpeedIcon },
  ]

  return (
    <aside className="dashboard-sidebar">
      <a className="dashboard-sidebar__brand" href="/" aria-label="CNERGI home">
        <img src={cnergiLogo} alt="CNERGI" />
      </a>

      <p className="dashboard-sidebar__label">menu</p>

      <nav className="dashboard-sidebar__nav" aria-label="Dashboard navigation">
        {navItems.map(({ label, icon: Icon, to, end }) => {
          if (to) {
            return (
              <NavLink
                className={({ isActive }) => getNavButtonClass(isActive)}
                end={end}
                key={label}
                to={to}
                aria-label={label}
                title={label}
              >
                <Icon aria-hidden="true" />
              </NavLink>
            )
          }

          return (
            <button
              className={getNavButtonClass()}
              key={label}
              type="button"
              aria-label={label}
              title={label}
            >
              <Icon aria-hidden="true" />
            </button>
          )
        })}
      </nav>

      <a className="dashboard-sidebar__support" href="#support" aria-label="Support">
        <DashboardIcon aria-hidden="true" />
      </a>
    </aside>
  )
}

export default MainDashboardSidebar
